const menus = {
  data() {
    const menus = [
      {
        name: '解決すること',
        href: '#link_point_issues',
      },
      {
        name: '特徴',
        href: '#link_point_features',
      },
      {
        name: '機能',
        href: '#link_point_functions',
      },
      {
        name: '導入効果',
        href: '#link_point_effects',
      },
      {
        name: '導入事例',
        href: '#link_point_casestudies',
      },
      {
        name: '導入手順',
        href: '#link_point_implementation-steps',
      },
      {
        name: 'よくあるご質問',
        href: '#link_point_questions',
      },
    ]
    return {
      menus,
    }
  },
}
export default menus



// WEBPACK FOOTER //
// ./src/mixins/menus.js